export default __webpack_public_path__ + "static/image8-d500b36059e7d505afe4f48758324026.jpeg";